

























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Area from "@/models/coding/areaModel";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from '@/enums/PermissionValue';
import IndicatorType from "@/models/indicator/indicatorType.model";
@Component
export default class IndicatorTypeTableComponent extends GenericBTable<IndicatorType> {

  created() {

    this.permissionValue = PermissionValue.CODIFICACIONES;
    this.tableConfig.controller = "IndicatorTypes"
    this.tableConfig.whereParams = `indicatorGroupId eq ${Number(this.$route.params.indicatorGroupId)}`;
    this.formatColumns();
  }

  formatColumns() {
    let indicatorType = new BTableColumn("name", "Tipo de indicador", false);
    this.tableConfig.insertColumns(indicatorType);
    this.tableConfig.actions.customTemplate = true;
  }
  verOpciones(row: any) {
    this.$router.push(`/indicatorGroup/${this.$route.params.indicatorGroupId}/indicatorType/${row.id}/indicator`);
  }
}
